import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';


const CHANGE_EVENT = 'change';

let _emailLogEntries = [];

let MailLogStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _emailLogEntries.filter(function(e) { return e !== undefined; });
    },
    add: function(entry) {
        let index = _emailLogEntries.findIndex(function(e) { return e !== undefined && e.id == entry.id;} );
        entry.timestamp = Date.parse(entry.dateAdded);
        if (0 <= index) {
            _emailLogEntries[index] = entry;
        } else {
            _emailLogEntries.push(entry);
        }
    },
    remove: function(id) {
        let index = _emailLogEntries.findIndex(function(e) { return e !== undefined && e.id == id;} );
        if (0 <= index) {
            delete _emailLogEntries[index];
        }
    },

});

MailLogStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.MAIL_LOG_LIST:
            action.data.forEach(MailLogStore.add);
            MailLogStore.emitChange();
            break;

        case ActionTypes.MAIL_LOG_LIST_ERROR:
            MailLogStore.emitChange();
            break;

        default:
            break;
    }

});

export default MailLogStore;
